var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74609 11.5795C2.74609 7.52838 2.74609 5.50282 4.00462 4.2443C5.26314 2.98577 7.28871 2.98577 11.3398 2.98577C15.3909 2.98577 17.4166 2.98577 18.675 4.2443C19.9336 5.50282 19.9336 7.52838 19.9336 11.5795C19.9336 15.6306 19.9336 17.6562 18.675 18.9147C17.4166 20.1733 15.3909 20.1733 11.3398 20.1733C7.28871 20.1733 5.26314 20.1733 4.00462 18.9147C2.74609 17.6562 2.74609 15.6306 2.74609 11.5795Z",
    stroke: "#9D9D9D",
    strokeWidth: 1.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4883 9.4311L9.19142 13.728M9.19141 9.43108L13.4883 13.728",
    stroke: "#9D9D9D",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose2);
export default __webpack_public_path__ + "static/media/icon-close2.656fd662782337246abdc46344b14cdc.svg";
export { ForwardRef as ReactComponent };